const BannedWords = [
  "10 year old",
  "10 years old",
  "11 year old",
  "11 years old",
  "12 year old",
  "12 years old",
  "13 year old",
  "13 years old",
  "14 year old",
  "14 years old",
  "15 year old",
  "15 years old",
  "16 year old",
  "16 years old",
  "17 year old",
  "17 years old",
  "1 year old",
  "1 years old",
  "2 year old",
  "2 years old",
  "3 year old",
  "3 years old",
  "420",
  "4 year old",
  "4 years old",
  "5 year old",
  "5 years old",
  "6 year old",
  "6 years old",
  "7 year old",
  "7 years old",
  "8 year old",
  "8 years old",
  "9 year old",
  "9 years old",
  "abduct",
  "abducted",
  "abducting",
  "abduction",
  "abduction",
  "abuse",
  "admireme",
  "adopt",
  "adopted",
  "adoption",
  "adopts",
  "age play",
  "age regression",
  "alcohol",
  "animal",
  "animal",
  "animals",
  "asleep",
  "asleep",
  "asphyxia",
  "asphyxiate",
  "asphyxiated",
  "asphyxiates",
  "asphyxiating",
  "asphyxiation",
  "asphyxiation",
  "asphyxicate",
  "asphyxication",
  "autopsy",
  "babies",
  "bait",
  "ballbusting",
  "bareback",
  "beaner",
  "beast",
  "beastial",
  "beastialism",
  "beastiality",
  "beastliness",
  "bestial",
  "bestiality",
  "bestiality",
  "blacked",
  "blackmail",
  "blackmailed",
  "blackmailer",
  "blackmailers",
  "blackmailing",
  "blackmails",
  "bled",
  "bleed",
  "bleeding",
  "bleeds",
  "blood",
  "blood",
  "bloodplay",
  "blunt",
  "booze",
  "booze",
  "bowl",
  "brainwashing",
  "brother sister",
  "brutal",
  "brutalisation",
  "brutality",
  "brutality",
  "brutalization",
  "brutalize",
  "brutalized",
  "brutalizes",
  "brutalizing",
  "brutally",
  "btoher",
  "bud",
  "buddha",
  "buds",
  "bukkake",
  "buzz",
  "caca",
  "caned",
  "caning",
  "cannibal",
  "cannibalism",
  "capture",
  "cbt",
  "cervics",
  "cerviks",
  "cervix",
  "cess",
  "child",
  "childhood",
  "childlike",
  "children",
  "children",
  "chinc",
  "chld",
  "chloroform",
  "chloroform",
  "chloroformed",
  "chloroformic",
  "chloroforming",
  "chloroformism",
  "chloroforms",
  "chlorophormic",
  "choke",
  "choking",
  "chronic",
  "chronophilia",
  "cnc",
  "coercion",
  "coma",
  "coma",
  "comatose",
  "cones",
  "consent",
  "coprophilia",
  "coprophiliac",
  "coprophilic",
  "coprophilism",
  "coprophilous",
  "cp",
  "crushing",
  "cycle",
  "daddy",
  "daddy brother",
  "daddy daughter",
  "daddy sister",
  "daughter brother",
  "deepfake",
  "deepfakes",
  "diapers",
  "disgrace",
  "dog",
  "doze",
  "drinking",
  "drug",
  "drugged",
  "drugging",
  "drugs",
  "drugs",
  "drunk",
  "drunk",
  "drunken",
  "drunkeness",
  "drunkenly",
  "drunkenness",
  "drunks",
  "enema",
  "entrance",
  "ephebophilia",
  "escort",
  "escorting",
  "extreme bondage",
  "extreme pain",
  "faded",
  "fanfuck",
  "farm",
  "father brother",
  "father daughter",
  "father sister",
  "fecal",
  "feces",
  "fetal",
  "fetal",
  "fisted",
  "fisting",
  "flogging",
  "foetal",
  "force",
  "forceable",
  "forced",
  "forcedbi",
  "forcedly",
  "forceful",
  "forcefully",
  "forcer",
  "forces",
  "forcible",
  "forcing",
  "forcing",
  "forcingly",
  "fuckafan",
  "fuckfan",
  "gangbang",
  "gangbangs",
  "gangrape",
  "gangraped",
  "gaping",
  "golden",
  "grass",
  "hardsports",
  "haze",
  "hebephilia",
  "herb",
  "hooker",
  "hypno",
  "hypnosis",
  "hypnosis",
  "hypnotism",
  "hypnotize",
  "hypnotized",
  "hypnotizes",
  "hypnotizing",
  "immobilization",
  "inbreed",
  "inbreeded",
  "inbreeding",
  "incapacitate",
  "incapacitated",
  "incapacitates",
  "incapacitating",
  "incapacitation",
  "incapacitation",
  "incest",
  "incest",
  "incestuous",
  "incestus",
  "inebriation",
  "infancy",
  "infant",
  "infant",
  "infanthood",
  "infantile",
  "infantilization",
  "infantlike",
  "infants",
  "intox",
  "intoxicable",
  "intoxicate",
  "intoxicated",
  "intoxicates",
  "intoxicating",
  "intoxication",
  "intoxication",
  "intoxicative",
  "intoxicator",
  "involuntary",
  "inzest",
  "jail",
  "jailbait",
  "joint",
  "kid",
  "kiddie",
  "kiddy",
  "kid fucking",
  "kid fucks",
  "kidnap",
  "kidnapped",
  "kidnapping",
  "kidnapping",
  "kid porn",
  "kids",
  "kid sex",
  "killing",
  "knock",
  "knocked",
  "kush",
  "lactate",
  "lactation",
  "liquor",
  "liquored",
  "little boy",
  "little boys",
  "little girl",
  "little girls",
  "little kid",
  "little kids",
  "lolicon",
  "lolita",
  "lolita",
  "lolitas",
  "lynching",
  "mary jane",
  "medicalplay",
  "meet",
  "menstrate",
  "menstrual",
  "menstruate",
  "menstruating",
  "menstruation",
  "mind control",
  "minor",
  "molest",
  "molestation",
  "molestation",
  "molested",
  "molester",
  "molesting",
  "molests",
  "murder",
  "murder",
  "murdered",
  "murderer",
  "murdering",
  "murders",
  "mutilate",
  "mutilated",
  "mutilates",
  "mutilating",
  "mutilation",
  "mutilation",
  "mutilator",
  "necromania",
  "necrophile",
  "necrophilia",
  "necrophiliac",
  "necrophilic",
  "necrophilism",
  "nigger",
  "non-consent",
  "paddling",
  "paedo",
  "paedophile",
  "paedophilia",
  "paedophiliac",
  "paralyzed",
  "paralyzed",
  "passed",
  "passed out",
  "passed out",
  "passes out",
  "passing out",
  "pass out",
  "pederast",
  "pedo",
  "pedofile",
  "pedofilia",
  "pedophile",
  "pedophilia",
  "pedophiliac",
  "pee",
  "peeplay",
  "pegging",
  "piss",
  "pissing",
  "poo",
  "poop",
  "poop",
  "pot",
  "preteen",
  "preteen",
  "preteens",
  "prostituted",
  "prostituting",
  "prostitution",
  "pse",
  "puke",
  "puke",
  "puked",
  "pukes",
  "puking",
  "punishbox",
  "quasi-unconscious",
  "race play",
  "rapable",
  "rape",
  "r.a.p.e",
  "rape",
  "rapeable",
  "raped",
  "raper",
  "rapes",
  "raping",
  "rapist",
  "restrictedwordtestzulu",
  "scat",
  "scat",
  "school kid",
  "sedate",
  "sedated",
  "sedately",
  "sedateness",
  "sedates",
  "sedating",
  "sedation",
  "sedation",
  "shit",
  "showers",
  "skat",
  "slave",
  "sleep",
  "sleep",
  "sleeping",
  "sleeps",
  "sleepy",
  "slept",
  "small kid",
  "smothering",
  "smuggling",
  "snuff",
  "speed",
  "stoned",
  "strangled",
  "strangling",
  "strangulation",
  "strangulation",
  "suffocate",
  "suffocation",
  "suffocation",
  "teen",
  "teenybopper",
  "teeny bopper",
  "teeny-bopper",
  "tentacle",
  "tentacled",
  "tentacles",
  "tipsy",
  "toilet",
  "toiletslave",
  "toiletslavery",
  "torture",
  "torture",
  "tortured",
  "trafficking",
  "trance",
  "twin",
  "twins",
  "unconscious",
  "unconsciously",
  "unconsciousness",
  "unconsciousness",
  "under 10 boy",
  "under 10 girl",
  "under 10 porn",
  "under 10 sex",
  "under 11 boy",
  "under 11 girl",
  "under 11 porn",
  "under 11 sex",
  "under 12 boy",
  "under 12 girl",
  "under 12 porn",
  "under 12 sex",
  "under 13 boy",
  "under 13 girl",
  "under 13 porn",
  "under 13 sex",
  "under 14 boy",
  "under 14 girl",
  "under 14 porn",
  "under 14 sex",
  "under 15 boy",
  "under 15 girl",
  "under 15 porn",
  "under 15 sex",
  "under 16 boy",
  "under 16 girl",
  "under 16 porn",
  "under 16 sex",
  "under 1 boy",
  "under 1 girl",
  "under 1 porn",
  "under 1 sex",
  "under 2 boy",
  "under 2 girl",
  "under 2 porn",
  "under 2 sex",
  "under 3 boy",
  "under 3 girl",
  "under 3 porn",
  "under 3 sex",
  "under 4 boy",
  "under 4 girl",
  "under 4 porn",
  "under 4 sex",
  "under 5 boy",
  "under 5 girl",
  "under 5 porn",
  "under 5 sex",
  "under 6 boy",
  "under 6 girl",
  "under 6 porn",
  "under 6 sex",
  "under 7 boy",
  "under 7 girl",
  "under 7 porn",
  "under 7 sex",
  "under 8 boy",
  "under 8 girl",
  "under 8 porn",
  "under 8 sex",
  "under 9 boy",
  "under 9 girl",
  "under 9 porn",
  "under 9 sex",
  "underage",
  "under age",
  "underage",
  "underaged",
  "under aged",
  "unwilling",
  "unwillingly",
  "unwillingness",
  "violation",
  "violence",
  "vomit",
  "vomit",
  "vomited",
  "vomiting",
  "vomits",
  "vomitted",
  "vomitting",
  "wasted",
  "wasted",
  "watersports",
  "weaponry",
  "weed",
  "whipping",
  "year kid",
  "young",
  "young kid",
  "zoophilia",
];

export default BannedWords;
